import React, { useState } from "react";
import Ledger from "./Ledger";
import Remittance from "./Remittance";
import "../styles/customerdashboard.css";

function CustomerDashboard() {
  const [activeTab, setActiveTab] = useState("ledger");

  return (
    <div className="customer-dashboard">

      <div className="toggle-wrapper">
        <button
          className={`toggle-btn ${
            activeTab === "ledger" ? "active" : ""
          }`}
          onClick={() => setActiveTab("ledger")}
        >
          Ledger
        </button>

        <button
          className={`toggle-btn ${
            activeTab === "remittance" ? "active" : ""
          }`}
          onClick={() => setActiveTab("remittance")}
        >
          Remittance
        </button>
      </div>

      <div className="tab-content">
        {activeTab === "ledger" ? (
          <Ledger />
        ) : (
          <Remittance />
        )}
      </div>

    </div>
  );
}

export default CustomerDashboard;